import { styled } from 'next-yak';

export const Wrapper = styled.div`
  height: 100%;
  max-width: 1440px;
  margin: 0 auto;

  background-color: var(--grey_100);

  position: relative;

  @media only screen and (min-width: 1442px) {
    border-left: 1px solid var(--grey_200);
    border-right: 1px solid var(--grey_200);
  }
`;
